import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useMsal } from "@azure/msal-react"
import { AuthenticationResult, InteractionRequiredAuthError } from '@azure/msal-browser'
import { setIdToken, setUserId } from '../store/features/authSlice'
import { loginRequest } from '../authConfig'
import { useEffect } from 'react'
import { useGetTokenQuery } from '../store/services/genieservice';
import { setOauthToken } from '../store/features/genieSlice'

export const useIdToken = () => {
  const { instance, accounts, inProgress } = useMsal();
  const [skip, setSkip] = useState(true)
  const [accessToken, setAccessToken] = useState<string | null>(null)
  const dispatch = useDispatch()
  const { refetch: refreshToken } = useGetTokenQuery({}, { skip: !accessToken });

  const getToken = async () => {
    let token: AuthenticationResult

    try {
      if (accounts.length > 0 && inProgress === "none") {
        instance.setActiveAccount(accounts[0])
        token = await instance.acquireTokenSilent(loginRequest)

        dispatch(setUserId(accounts[0].username))
        dispatch(setIdToken(token.idToken))
        setAccessToken(token.idToken)
        setSkip(false)

        return token
      }
    } catch (error: any) {
      if (error instanceof InteractionRequiredAuthError) {
        console.warn("interaction required auth error")
        const response = await instance.acquireTokenPopup(loginRequest);
        setAccessToken(response.idToken)
        dispatch(setUserId(response.account?.username))
        dispatch(setIdToken(response.idToken))
        setSkip(false)
      }
    }
  }

  // Monitor MSAL authentication progress
  useEffect(() => {
    const handleToken = async () => {
      if (accounts.length > 0 && inProgress === "none") {
        await getToken();
        refreshToken()
      }
    };

    const interval = setInterval(() => {
      dispatch(setOauthToken(null))
      handleToken();
    }, 1000 * 60 * 45);

    handleToken();

    return () => clearInterval(interval);
  }, [accounts, inProgress]);

  return { getToken }
}
